import { render, staticRenderFns } from "./CurationWriteDefaultLayout.vue?vue&type=template&id=073eb486&scoped=true&"
import script from "./CurationWriteDefaultLayout.vue?vue&type=script&lang=js&"
export * from "./CurationWriteDefaultLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073eb486",
  null
  
)

export default component.exports